const MangoPaymentTypeForDisplay = {
    0: "PayIn",
    1: "TransferDebiting",
    2: "TransferCrediting",
    3: "PayOut",
};


export default MangoPaymentTypeForDisplay;
